export default function Screenshots() {
  return (
    <section className="max-w-6xl mx-auto px-6 py-16">
      <h2 className="text-4xl font-bold text-blue-600 mb-10 text-center">
        See Popalooza in Action
      </h2>

      {/* Screenshot grid */}
      <div className="grid md:grid-cols-2 gap-8 mb-12">
        <img
          src="images/home.jpg"
          alt="Popalooza Level 1 gameplay"
          className="rounded-lg shadow-md hover:scale-105 transition-transform"
        />
        <img
          src="images/game.jpg"
          alt="Popalooza rewards and stars"
          className="rounded-lg shadow-md hover:scale-105 transition-transform"
        />
      </div>

      {/* Gameplay trailer */}
      <div className="flex justify-center">
        <iframe
          className="rounded-lg shadow-lg w-full md:w-3/4 h-64 md:h-96"
          src="https://www.youtube.com/embed/ctGa7BUrXbU"
          title="Popalooza Gameplay"
          frameBorder="0"
          allowFullScreen
        ></iframe>
      </div>
    </section>
  );
}
